export enum ClientTheme {
  Default = 0,
  Light = 1,
  Dark = 2,
}

/** Modelo de relatório configurado por cliente. Espelha o enum ReportModel do back-end. */
export type ReportModel = 'GRI' | 'SASB' | 'Hibrido' | 'BancoDoBrasil';

export interface ClientSettings {
  clientId: string;
  defaultTheme: ClientTheme;
  primaryColor: string | null;
  secondaryColor: string | null;
  accentColor: string | null;

  /**
   * Chave armazenada no banco de dados.
   */
  logoObjectKey: string | null;

  /**
   * URL pública calculada pelo backend.
   *
   * Temporariamente opcional para não quebrar caso
   * o backend ainda não esteja devolvendo esse campo.
   */
  logoUrl?: string | null;

  /** Modelo de relatório configurado (null quando nenhum modelo foi definido). */
  reportModel: ReportModel | null;
}

export interface ClientColorSettingsUpdateRequest {
  defaultTheme: ClientTheme;
  primaryColor: string | null;
  secondaryColor: string | null;
  accentColor: string | null;
}

export interface UpdateReportModelRequest {
  reportModel: ReportModel | null;
}

export interface ClientSettingsUpdateResult {
  success: boolean;
  data?: ClientSettings;
  error?: string;
}
